let apiBase = 'https://dev.renovationtrust.com/api/v1/';
let urlBase = 'https://dev.renovationtrust.com/';
let appBase = 'https://app.dev.renovationtrust.com/';
let isDev = true;

if (window.location.origin === 'https://app.renovationtrust.com'){
  apiBase = 'https://www.renovationtrust.com/api/v1/';
  urlBase = 'https://www.renovationtrust.com/';
  appBase = 'https://app.renovationtrust.com/';
  isDev = false;
}

const api = {
  base: apiBase,
}
const url = {
  base: urlBase,
}

const app = {
  base: appBase,
}

// console.log('DevProd.js: ');
// console.log('api: ', api);
// console.log('url: ', url);
// console.log('isDev: ', isDev);

export {
  api,
  url,
  app,
  isDev,
}